<template>
    <csp-desktop-info-card
        v-if="formContext.isLoaded"
        :cols="cols"
        :form-context="formContext"
        icon="inticon-autoclaim_company"
        :prevent-default-on-cancel="isCreationForm"
        title="Firma"
        @cancel-form="handleCancel"
        @save="saveFirmBasedata">
        <div v-if="showChangelogButton" class="float-right">
            <csp-changelog-modal :changelog-url="firmChangelogUrl"/>
        </div>
        <h2>Zugehörigkeit</h2>
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Vertriebspartner"
                :options-loader="loadOptions('resellers')"
                property="reseller"
                type="autocomplete"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Kategorie"
                :options-loader="loadOptions('firmCategories')"
                property="firmCategory"
                :required="true"
                type="autocomplete"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Zuordnung"
                :options-loader="loadOptions('firmAssociationWithoutGroups', {includeGroups: false})"
                property="firmAssociation"
                type="autocomplete"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Firmengruppe"
                :options-loader="loadOptions('firmGroup')"
                property="firmGroup"
                type="autocomplete"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Gebiet"
                :options-loader="loadOptions('areas')"
                property="area"
                type="autocomplete"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Flottenkunde"
                property="isFleetCustomer"
                type="checkbox"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Großkunde"
                property="isMajorCustomer"
                type="checkbox"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Haupt-Reparaturbetrieb"
                :options-loader="loadOptions(
                    'mainCarDealerFirm',
                    {firmGroupId: formContext.form.data.firmGroup, firmId: firmId})"
                property="mainCarDealerFirm"
                type="autocomplete"/>
        </b-row>
        <hr>
        <h2>Adressdaten</h2>
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Name"
                property="name"
                :required="true"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Name Zusatz"
                property="nameAffix"
                type="text"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Straße"
                property="street"
                :required="true"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="PLZ"
                property="postalCode"
                :required="true"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Ort"
                property="city"
                :required="true"
                type="text"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Land"
                :options-loader="loadOptions('countries')"
                property="country"
                :required="true"
                type="autocomplete"/>
            <csp-desktop-info-card-element
                class="col-3"
                :dependencies="['country']"
                :form-context="formContext"
                label="Region"
                :options-loader="loadOptions('regions', {countryId: formContext.form.data.country})"
                property="region"
                :required="true"
                type="autocomplete"/>
        </b-row>
        <hr>
        <h2>Kontaktdaten</h2>
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="E-Mail administrativ"
                property="email"
                :required="true"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="E-Mail Benachrichtigung"
                property="notificationEmail"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="E-Mail Datenschutzbeauftragter"
                property="dataProtectionCommissionerMail"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="zusätzliche E-Mail für Rückrufbitten"
                property="callbackEmail"
                type="text"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="E-Mail QM Beauftragte"
                property="qmCommissionerMail"
                type="textarea"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Telefon"
                property="phone"
                :required="true"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Internet"
                property="internet"
                type="text"/>
        </b-row>

        <b-row v-if="showActionButtons" class="mt-3">
            <b-col cols="6"/>
            <b-col class="text-right" cols="6">
                <b-button v-if="showDeleteButton" @click="openDeleteConfirmationModal">
                    Firma löschen
                </b-button>
            </b-col>
        </b-row>

        <b-modal v-model="isDeleteConfirmationModalOpen" cancel-title="Abbrechen" title="Firma löschen"
            @ok="deleteFirm">
            Wollen Sie die Firma wirklich löschen?
        </b-modal>
    </csp-desktop-info-card>
</template>

<script>
    import Container from '@services/Container';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';

    const container = Container.getInstance();
    const firmRepository = container.getDesktopFirmRepository();
    const flashMessenger = container.getFlashMessenger();

    export default {
        name: 'FirmBasedata',
        mixins: [FormDataMixin],
        props: {
            cols: {
                type: Number,
                default: 12,
            },
            isCreationForm: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                isDeleteConfirmationModalOpen: false,
            };
        },
        computed: {
            firmId() {
                return this.$route.params.firmId;
            },
            firmChangelogUrl() {
                return '/api/desktop/firms/' + this.firmId + '/basedata/changelog';
            },
            showChangelogButton() {
                return this.formContext.data.isEntityNew === false
                    && !this.formContext.isInEditMode
                    && this.formContext.permissions.showChangelog === true;
            },
            showActionButtons() {
                return this.showDeleteButton;
            },
            showDeleteButton() {
                return this.formContext.data.isEntityNew === false
                    && !this.formContext.isInEditMode
                    && this.formContext.permissions.canDelete === true;
            },
        },
        created() {
            this.reloadHandlers.firmBasedata = this.reloadFirmBasedata;
        },
        methods: {
            handleCancel() {
                // only relevant for creation form
                if (!this.isCreationForm) {
                    return;
                }

                window.history.back();
            },
            loadOptions(type, urlParameter = {}) {
                return () => {
                    return firmRepository.loadLegacySelectOptions(type, urlParameter);
                }
            },
            saveFirmBasedata(formContext) {
                if (this.isCreationForm) {
                    this.saveCreate(formContext);
                } else {
                    this.saveUpdate(formContext);
                }
            },
            saveCreate(formContext) {
                const saveFunction = (objectId, postData) => {
                    return firmRepository.create(postData);
                };
                this.saveFormData(formContext, saveFunction);
            },
            saveUpdate(formContext) {
                const saveFunction = (objectId, postData) => {
                    return firmRepository.saveFirmBasedata(objectId, postData);
                };
                this.saveFormData(formContext, saveFunction);
            },
            reloadFirmBasedata(formContext) {
                if (this.isCreationForm) {
                    this.reloadCreate(formContext);
                } else {
                    this.reloadUpdate(formContext);
                }
            },
            reloadCreate(formContext) {
                const reloadFunction = (objectId, postData) => {
                    return firmRepository.reloadCreate(postData);
                };
                this.reloadFormData(formContext, reloadFunction);
            },
            reloadUpdate(formContext) {
                const reloadFunction = (objectId, postData) => {
                    return firmRepository.reloadFirmBasedata(this.firmId, postData);
                };
                this.reloadFormData(formContext, reloadFunction);
            },
            openDeleteConfirmationModal() {
                this.isDeleteConfirmationModalOpen = true;
            },
            deleteFirm() {
                this.formContext.isLoading++;
                firmRepository.delete(this.firmId).then(
                    () => {
                        flashMessenger.addSuccess('Firma wurde gelöscht');
                        window.location.href = '/de/Schaden-Manager/Firma';
                    },
                    () => {
                        flashMessenger.addError('Firma konnte nicht gelöscht werden');
                    }
                ).finally(() => {
                    this.formContext.isLoading--;
                });
            },
        },
    }
</script>
